module.exports = __webpack_public_path__ + "img/united-kingdom.d7ee6400.png";